import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getUrlGrupos,
  insertUrlGrupo,
  updateUrlGrupo,
  deleteUrlGrupo,
  getUrlGrupoById,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_URL_GRUPOS(action) {
  try {
    const urlGruposData = yield call(getUrlGrupos, action.payload)
    if (urlGruposData.ok) {
      yield put({
        type: actions.URL_GRUPOS_LOAD_SUCCEEDED,
        payload: urlGruposData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Url Grupos')
      put({
        type: actions.URL_GRUPOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URL_GRUPOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_URL_GRUPO(action) {
  try {
    const urlGrupoObj = yield call(insertUrlGrupo, action.payload)
    if (urlGrupoObj.ok) {
      putMessage(messageType.SUCCESS, 'Url Grupo creada correctamente')
      yield put({
        type: actions.URL_GRUPO_INSERT_SUCCEEDED,
        payload: urlGrupoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Url Grupo')
      yield put({
        type: actions.URL_GRUPO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear  Url Grupo')
    yield all([
      put({
        type: actions.URL_GRUPO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_URL_GRUPO(action) {
  try {
    const urlGrupoObj = yield call(updateUrlGrupo, action.payload)
    if (urlGrupoObj.ok) {
      putMessage(messageType.SUCCESS, 'Url Grupo modificada correctamente')
      yield put({
        type: actions.URL_GRUPO_UPDATE_SUCCEEDED,
        payload: urlGrupoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Url Grupo')
      yield put({
        type: actions.URL_GRUPO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Url Grupo')
    yield all([
      put({
        type: actions.URL_GRUPO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_URL_GRUPO(action) {
  try {
    const urlGrupoResult = yield call(deleteUrlGrupo, action.payload)
    if (urlGrupoResult.ok) {
      putMessage(messageType.SUCCESS, 'Url Grupo eliminada correctamente')
      yield put({
        type: actions.URL_GRUPO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Url Grupo')
      yield put({
        type: actions.URL_GRUPO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Url Grupo')
    yield all([
      put({
        type: actions.URL_GRUPO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_URL_GRUPO_BY_ID(action) {
  try {
    const urlGrupoData = yield call(getUrlGrupoById, action.payload)
    if (urlGrupoData.ok) {
      yield put({
        type: actions.URL_GRUPO_BYID_LOAD_SUCCEEDED,
        payload: urlGrupoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Url Grupo')
      put({
        type: actions.URL_GRUPO_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.URL_GRUPO_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.URL_GRUPOS_LOAD_REQUESTED, GET_URL_GRUPOS),
    takeEvery(actions.URL_GRUPO_INSERT_REQUESTED, INSERT_URL_GRUPO),
    takeEvery(actions.URL_GRUPO_UPDATE_REQUESTED, UPDATE_URL_GRUPO),
    takeEvery(actions.URL_GRUPO_DELETE_REQUESTED, DELETE_URL_GRUPO),
    takeEvery(actions.URL_GRUPO_BYID_LOAD_REQUESTED, GET_URL_GRUPO_BY_ID),
  ])
}
